module.exports = __webpack_public_path__ + "static/media/blueberry.84f65783.jpg";